import React from 'react';
import SinglePane from '../SinglePane';
import { usePaneViewer } from '../PaneViewer';
import { Button, Flex } from '@smarterservices/smarter-ui';
import StepInstructions from '../Common/StepInstructions';
import { sendMessageToExtension } from '../../helpers/helpers';
import { completeAndGetNextStep } from '../../routes/Onboarding/api';

const ReconnectCompleted = ({ stepData, journeyStepId, isInSession }) => {
  const { onNext } = usePaneViewer();

  const handleNext = async () => {
    if (isInSession) {
      //
      await completeAndGetNextStep(journeyStepId)
      await sendMessageToExtension({
        message: 'sp_background__stopInSessionReconnect',
      });
      return;
    }
    onNext();
  };

  return (
    <>
      {stepData && (
        <SinglePane>
          <Flex direction="column" height="100%" justifyContent="center" alignItems="center" gap="medium">
            <StepInstructions instructions={stepData?.body} />
            <Button
              color="primary"
              onClick={handleNext}
              margin="0 small"
            >
              Resume Session
            </Button>
          </Flex>
        </SinglePane>
      )}
    </>
  );
};

export default ReconnectCompleted;